import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class ExchangeRateUnitsGreaterThanZeroError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.exchange-rate.rate.exchange-rate-unit-should-be-greater-than-zero');
    }
}
